<template>
  <div class="contaner">
    <a-tabs :activeKey="currTabKey" @change="changeTab">
      <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.tab">
        <component :is="item.key" style="min-height: 600px" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import StudentProfile from './components/StudentProfile'
import TeacherContactList from './components/TeacherContactList'
import ParentContactList from './components/ParentContactList'
export default {
  name: 'DynamicMonitor',
  components: {
    StudentProfile,
    TeacherContactList,
    ParentContactList,
  },
  data() {
    return {
      currTabKey: 'StudentProfile',
      tabList: [
        {
          tab: '学生概览',
          key: 'StudentProfile',
        },
        {
          tab: '班主任联系单',
          key: 'TeacherContactList',
        },
        {
          tab: '家长联系单',
          key: 'ParentContactList',
        },
      ],
    }
  },
  created() {},
  methods: {
    changeTab(key) {
      console.log(key)
      this.currTabKey = key
    },
  },
}
</script>
<style scoped lang="less">
.contaner {
  min-height: 80vh;
  padding: 0 20px;
  background-color: #fff;
  border-radius: 10px;
}
</style>
